import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { PartnerTransactionsState } from "./types";
import { fetchPartnerTransactions } from "./partner-transactions-thunk";
import { ErrorType } from "@/shared/types";

const currentDate = new Date()

const initialState: PartnerTransactionsState = {
    transactions: [],
    isLoading: false,
    isFirstLoad: true,
    error: null,
    page: 1,
    limit: 50,
    startDate: new Date(currentDate.getFullYear(), currentDate.getMonth(), 1),
    endDate: new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 1),
    partnerId: null,
    storeId: null,
    clientType: null,
    search: null,
    totalPages: 0
}

const partnerTransactionsSlice = createSlice({
    name: 'partnerTransactions',
    initialState,
    reducers: {
        setSelectedPartner(state, action: PayloadAction<string | null>) {
            state.partnerId = action.payload ? [action.payload] : null
            state.storeId = null
            state.page = 1
        },
        setSelectedStore(state, action: PayloadAction<string | null>) {
            state.storeId = action.payload ? [action.payload] : null
            state.page = 1
        },
        setSearch(state, action: PayloadAction<string | null>) {
            state.search = action.payload?.length ? action.payload : null
            state.page = 1
        },
        setClientType(state, action: PayloadAction<"fiz" | "legal" | null>) {
            state.clientType = action.payload
            state.page = 1
        },
        setStartDate(state, action: PayloadAction<Date>) {
            state.startDate = action.payload
            state.page = 1
        },
        setEndDate(state, action: PayloadAction<Date>) {
            state.endDate = action.payload
            state.page = 1
        },
        setPage(state, action: PayloadAction<number>) {
            state.page = action.payload
        },
    },
    extraReducers(builder) {
        builder
        .addCase(fetchPartnerTransactions.pending, (state) => {
            state.isLoading = true
            state.error = null
        })
        .addCase(fetchPartnerTransactions.fulfilled, (state, action) => {
            state.isLoading = false
            state.isFirstLoad = false
            state.transactions = action.payload.items
            state.totalPages = action.payload.totalPages
            state.error = null
        })
        .addCase(fetchPartnerTransactions.rejected, (state, action) => {
            state.isLoading = false
            state.error = action.payload as ErrorType ?? null
        })
    },
})

export default partnerTransactionsSlice.reducer
export const { setSelectedPartner, setSelectedStore, setClientType, setSearch, setEndDate, setStartDate, setPage } = partnerTransactionsSlice.actions